import { computed } from 'vue'
import type { ComputedRef } from 'vue'
// types
import type { StrapiHeaderTopItem } from '@ts-strapi/interfaces'
// constants
import { STRAPI_HEADER_ITEM_TYPE } from '@ts-strapi/enums'

export interface HeaderMobileItemProps {
  item: StrapiHeaderTopItem
  isExpanded: boolean
}

interface HeaderMobileItemOptions {
  props: HeaderMobileItemProps
  onExpand: () => void
  onCollapse: () => void
}

interface HeaderMobileItemReturn {
  refIsMega: ComputedRef<boolean>
  handleToggle: () => void
}

export const useHeaderMobileItem = ({ props, onExpand, onCollapse }: HeaderMobileItemOptions): HeaderMobileItemReturn => {
  const refIsMega = computed<boolean>(() =>
    props.item.__component === STRAPI_HEADER_ITEM_TYPE.MultipleMenu
    || props.item.__component === STRAPI_HEADER_ITEM_TYPE.SingleMenu,
  )

  const handleToggle = (): void => {
    if (props.isExpanded) onCollapse()
    else onExpand()
  }

  return {
    refIsMega,
    handleToggle,
  }
}